import { useSetAtom } from 'jotai';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Flex, IconSvg } from '@/lib/v2/components';
import { CreateIcon } from '@/lib/v2/icons/outline';

import { TRANSLATE_WHATSAPP_ACTION_FORM } from '@/src/modules/CampaignsModule/constants';

import { atomTemplateOption } from '@/modules/CampaignsModule/atoms/actionWhatsAppAtom';
import { TEMPLATE_OPTION } from '@/modules/CampaignsModule/components/actionManagement/WhatsAppAction/constants';
import { SendWhatsAppModal } from '@/modules/ContactsModule/components/SendWhatsAppModal';

const TemplateOptions = () => {
  const { t } = useTranslation('inbox');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const setTemplateOption = useSetAtom(atomTemplateOption);

  const handleCloseModal = useCallback(() => {
    setModalIsOpen(false);
  }, [setModalIsOpen]);

  const handleOpenModal = useCallback(() => {
    setModalIsOpen(true);
  }, [setModalIsOpen]);

  const handleCreateTemplate = useCallback(() => {
    setTemplateOption(TEMPLATE_OPTION.CREATE);
  }, [setTemplateOption]);

  return (
    <>
      <Flex withGap alignment="center" gapSize="medium" itemAlignment="center">
        <Button
          outline
          secondary
          id="select-template-button"
          size="small"
          onClick={handleOpenModal}
        >
          {t(`${TRANSLATE_WHATSAPP_ACTION_FORM}.selectTemplateButtonText`)}
        </Button>
        <Button
          outline
          secondary
          iconLeft={<IconSvg strokeColor="gray" svgComponent={<CreateIcon />} />}
          id="create-template-button"
          size="small"
          onClick={handleCreateTemplate}
        >
          {t(`${TRANSLATE_WHATSAPP_ACTION_FORM}.createTemplateButtonText`)}
        </Button>
      </Flex>
      <SendWhatsAppModal isOpen={modalIsOpen} onClose={handleCloseModal} />
    </>
  );
};

export default TemplateOptions;
